import {
  FieldRequestFieldEnum,
  FieldRequestTypeEnum,
} from "@/features/common/enums";
import type { IFieldRequestInput } from "@/features/lender-responses/types/lender-response";

// create a type for the DEFAULT_FIELD_REQUESTS object
type DefaultFieldRequests = Partial<
  Record<FieldRequestFieldEnum, IFieldRequestInput>
>;

// create the DEFAULT_FIELD_REQUESTS object
export const DEFAULT_FIELD_REQUESTS: DefaultFieldRequests = {
  [FieldRequestFieldEnum.guarantors]: {
    field: FieldRequestFieldEnum.guarantors,
    config: {
      numberOfRequiredGuarantors: 1,
      reducedGuarantorPercentTo: null,
      guarantorCommitmentAmount: null,
    },
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.COLLATERAL,
  },

  [FieldRequestFieldEnum.parent_company_guarantee]: {
    field: FieldRequestFieldEnum.parent_company_guarantee,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.COLLATERAL,
  },
  [FieldRequestFieldEnum.property]: {
    field: FieldRequestFieldEnum.property,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.COLLATERAL,
  },
  [FieldRequestFieldEnum.company_mortgage]: {
    field: FieldRequestFieldEnum.company_mortgage,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.COLLATERAL,
  },
  [FieldRequestFieldEnum.share_mortgage]: {
    field: FieldRequestFieldEnum.share_mortgage,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.COLLATERAL,
  },
  [FieldRequestFieldEnum.pawned_invoices]: {
    field: FieldRequestFieldEnum.pawned_invoices,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.COLLATERAL,
  },
  [FieldRequestFieldEnum.reason]: {
    field: FieldRequestFieldEnum.reason,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.ADDITIONAL_INFORMATION,
  },
  [FieldRequestFieldEnum.reason_explanation]: {
    field: FieldRequestFieldEnum.reason_explanation,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.ADDITIONAL_INFORMATION,
  },
  [FieldRequestFieldEnum.accounting_data]: {
    field: FieldRequestFieldEnum.accounting_data,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.ADDITIONAL_INFORMATION,
  },
  [FieldRequestFieldEnum.annual_report]: {
    field: FieldRequestFieldEnum.annual_report,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.ADDITIONAL_INFORMATION,
  },
  [FieldRequestFieldEnum.construction_estimate]: {
    field: FieldRequestFieldEnum.construction_estimate,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.ADDITIONAL_INFORMATION,
  },
  [FieldRequestFieldEnum.banking_data]: {
    field: FieldRequestFieldEnum.banking_data,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.ADDITIONAL_INFORMATION,
  },
  [FieldRequestFieldEnum.unpaid_invoices_additional_data]: {
    field: FieldRequestFieldEnum.unpaid_invoices_additional_data,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.ADDITIONAL_INFORMATION,
  },
  [FieldRequestFieldEnum.leasing_additional_data]: {
    field: FieldRequestFieldEnum.leasing_additional_data,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.ADDITIONAL_INFORMATION,
  },
  [FieldRequestFieldEnum.budget]: {
    field: FieldRequestFieldEnum.budget,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.ADDITIONAL_INFORMATION,
  },
  [FieldRequestFieldEnum.additional_securities]: {
    field: FieldRequestFieldEnum.additional_securities,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.ADDITIONAL_INFORMATION,
  },
  [FieldRequestFieldEnum.building_permit]: {
    field: FieldRequestFieldEnum.building_permit,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.ADDITIONAL_INFORMATION,
  },
  [FieldRequestFieldEnum.property_cash_flow]: {
    field: FieldRequestFieldEnum.property_cash_flow,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.ADDITIONAL_INFORMATION,
  },
  [FieldRequestFieldEnum.property_additional_data]: {
    field: FieldRequestFieldEnum.property_additional_data,
    config: null,
    lenderComment: null,
    isCollectedByLender: false,
    type: FieldRequestTypeEnum.ADDITIONAL_INFORMATION,
  },
} as const;
